import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../../hooks/useNotifications'
import { deleteGroupMember } from '../../../../services/groupsService'
import { UserContext } from '../../UserContext'
import DeleteUserGroupsList from '../DeleteUserGroupsList'

export default function DeleteGroupUserDialogOverlay({
  memberSummaries,
  refreshUserGroupsDataAndControls,
  ...overlay
}) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const { currentUser } = useContext(UserContext)
  const bodyText = getBodyText(memberSummaries)

  const confirmBtnOnClick = async () => {
    overlay.close()
    try {
      await Promise.all(
        memberSummaries.map((memberSummary) => {
          return deleteGroupMember(memberSummary.id, currentUser.dmcUser.cisId)
        })
      )
    } catch (err) {
      error(
        memberSummaries.length > 1
          ? t('user.errors.deletingUsers', {
              defaultValue: `Error deleting user from groups: ${err.message || ''}`,
              message: err.message || '',
            })
          : t('user.errors.deletingUser', {
              defaultValue: `Error deleting user from group: ${err.message || ''}`,
              message: err.message || '',
            }),
        err
      )
    }
    refreshUserGroupsDataAndControls()
  }

  return (
    <DialogOverlay
      id="Delete Group User overlay"
      {...overlay}
      title={t('user.groups.dialogOverlay.delete.heading', 'Delete User')}
    >
      <Paragraph size="sm">{t(bodyText.key, bodyText.value)}</Paragraph>
      <DeleteUserGroupsList memberSummaries={memberSummaries} />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="Delete Group User Cancel button" emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

function getBodyText(memberSummaries) {
  const bodyText = {
    key: 'user.groups.dialogOverlay.delete.body.singleGroup',
    value: 'Are you sure you want to delete this user from this group?',
  }
  if (memberSummaries.length > 1) {
    bodyText.key = 'user.groups.dialogOverlay.delete.body.multipleGroups'
    bodyText.value = 'Are you sure you want to delete this user from these groups?'
  }
  return bodyText
}
